export const PAYMENT_METHODS = [
  { value: "all", label: "All methods" },
  { value: "cash", label: "Cash" },
  { value: "card", label: "Card" },
  { value: "credit", label: "Credit" },
  { value: "mixed", label: "Split / mixed" },
];

export const ORDER_TYPES = [
  { value: "all", label: "All order types" },
  { value: "DI", label: "Dine In" },
  { value: "TA", label: "Take Away" },
  { value: "DL", label: "Delivery" },
];

export function paymentMethodLabel(value) {
  return PAYMENT_METHODS.find((m) => m.value === value)?.label || "All methods";
}

export function orderTypeLabel(value) {
  return ORDER_TYPES.find((o) => o.value === value)?.label || "All order types";
}

export function formatReportFilterLine({
  fromDate,
  toDate,
  date,
  asOf,
  paymentMethod,
  orderType,
  extra = [],
} = {}) {
  const parts = [];
  if (fromDate && toDate) parts.push(`Period: ${fromDate} to ${toDate}`);
  else if (asOf) parts.push(`As of ${asOf}`);
  else if (date) parts.push(`Date: ${date}`);
  extra.filter(Boolean).forEach((part) => parts.push(part));
  if (orderType && orderType !== "all") {
    parts.push(`Order: ${orderTypeLabel(orderType)}`);
  }
  if (paymentMethod && paymentMethod !== "all") {
    parts.push(`Payment: ${paymentMethodLabel(paymentMethod)}`);
  }
  return parts.join(" · ");
}
